import React, { useContext, useEffect } from 'react';

import { AppShellContext } from '../utils/contexts';

const AuthWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { initAuth, userDetails } = useContext(AppShellContext);

  useEffect(() => {
    if (!userDetails) {
      initAuth();
    }
  }, [initAuth, userDetails]);

  return userDetails ? children : <span>Loading...</span>;
};

export default AuthWrapper;
